import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Device } from "components/Navbars/DeviceStatus";
import { getStatusColor } from "services/utils/Status";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { showToast } from "services/utils/Status";
import * as Mui from "@mui/material";
import styled from "styled-components";
import moment from "moment";
import { themes, defaultAllSelection } from "services/constants";
import { ListView } from "./ListView";
import { CardView } from "./CardView";
import { customGetAPI } from "services/utils/CustomAPI";
import {
  setAttendanceShiftName,
  setAttendanceShiftId,
  setAttendanceDate,
} from "services/Redux/TeamZone";
import { CreditCard, List, DownloadForOffline } from "@mui/icons-material";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import { setReloadHRMSApi } from "services/Redux/leaveManagement";
import { LoaderWithoutHeight } from "components/Loader";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { tooltipStyleProps } from "services/constants/Styles";

export const Status = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    token,
    domain,
    globalSearchValue,
    userDetails,
    topbarCompanyId,
    topbarCompanyName,
  } = useSelector((state) => state.tokenReducer);
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const { attendanceShiftName, attendanceShiftId, attendanceDate } =
    useSelector((state) => state.teamZoneReducer);
  let reloadHRMSApi = useSelector((state) => state.leaveReducer.reloadHRMSApi);
  const [filterDepartMemberList, setFilterDepartMemberList] = useState([]);
  const [selectedValue, setSelectedValue] = useState("All");
  const [statusTag, setStatusTag] = useState("");
  const [allTagStatus, setAllTagStatus] = useState("");
  const [presentTag, setPresentTag] = useState("");
  const [openSidePeek, setOpenSidePeek] = useState(false);
  const [loading, setLoading] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [shiftId, setshiftId] = useState(attendanceShiftId);
  const [getShiftDetails, setGetShiftDetails] = useState(true);
  const [shiftData, setShiftData] = useState([]);
  const [shiftName, setShiftName] = useState(attendanceShiftName);
  const [departmentMembers, setDepartmentMembers] = useState([]);
  const [deviceOffine, setDeviceOffline] = useState(false);
  const [date, setDate] = useState(attendanceDate);
  const [view, setView] = useState("Card");
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [expand, setExpand] = useState(false);
  const [page, setPage] = useState(0);
  const [editCheckinCheckOutTime, setEditCheckInCheckOutDetails] = useState({});
  const [editCheckinDetailsId, setEditCheckinDetailsId] = useState(0);
  const [handleLoading, setHandleLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [shiftDetails, setShiftDetails] = useState([]);
  const [getUser, setGetUser] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const now = new Date();

  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const formattedTime = `${hours}:${minutes}`;
  const formattedDateTime = `${formattedDate}-${formattedTime}`;

  useEffect(() => {
    dispatch(setReloadHRMSApi(true));
  }, [dispatch]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      const allDepartment = {
        id: defaultAllSelection,
        label: "All",
        department_name: "All",
      };
      const res = await customGetAPI(
        `${domain}get-department/?user_id=${userDetails.id}`
      );
      if (res.ok) {
        setDepartmentData([
          allDepartment,
          ...res?.responseDetails.map((obj) => ({
            ...obj,
            label: obj.department_name,
          })),
        ]);
      }
    };
    fetchDepartmentData();
  }, [domain, token, userDetails.id]);
  const fetchShiftDetailsDetails = async (id, dep_name) => {
    const allShifts = {
      id: defaultAllSelection,
      label: "All",
      name: "All",
    };
    const res = await customGetAPI(
      `${domain}shift-filter/?department_id=${id}&user_id=${userDetails?.id}&date=${date}`
    );
    if (res.ok) {
      setShiftName(allShifts?.label);
      setshiftId(allShifts?.id);
      let data =
        res?.responseDetails?.length !== 0
          ? [allShifts, ...res?.responseDetails]
          : [allShifts];
      setShiftData(data);
    } else {
      setShiftName(allShifts?.label);
      setshiftId(allShifts?.id);
      setShiftData(allShifts);
    }
  };

  useEffect(() => {
    const fetchShiftDetails = async () => {
      const allShifts = {
        id: defaultAllSelection,
        label: "All",
        name: "All",
      };
      const res = await customGetAPI(
        `${domain}shift-filter/?department_id=${departmentId}&user_id=${userDetails?.id}&date=${date}`
      );
      if (res.ok) {
        let data =
          res?.responseDetails?.length !== 0
            ? [allShifts, ...res?.responseDetails]
            : [allShifts];
        setShiftData(data);
      } else {
        setShiftData(allShifts);
      }
    };
    if (getShiftDetails && date && departmentId) {
      fetchShiftDetails();
      setGetShiftDetails(false);
    }
  }, [
    date,
    departmentId,
    departmentName,
    dispatch,
    domain,
    getShiftDetails,
    token,
    userDetails?.id,
  ]);

  const fetchStatus = useCallback(async () => {
    setLoading(handleLoading ? false : true);
    let url = `${domain}checkinfilter/?department_id=${departmentId}&date=${date}&shift_id=${shiftId}&user_id=${userDetails.id}&status=${statusTag}&company_id=${topbarCompanyId}`;
    const res = await customGetAPI(url);
    if (res.ok) {
      if (res.code === 202) {
        setDeviceOffline(true);
        setHandleLoading(false);
        dispatch(setReloadHRMSApi(false));
      } else {
        dispatch(setReloadHRMSApi(false));
        setDepartmentMembers(res?.responseDetails);
        if (getUser) {
          const updatedUserDetails =
            res?.responseDetails?.user_status_details?.find(
              (member) => member.user_id === userId
            );
          setShiftDetails(updatedUserDetails);
          setFirstTime(true);
        }
        setDeviceOffline(false);
        setHandleLoading(false);
      }
      setLoading(false);
    }
  }, [
    date,
    departmentId,
    dispatch,
    domain,
    getUser,
    handleLoading,
    shiftId,
    statusTag,
    topbarCompanyId,
    userDetails.id,
    userId,
  ]);

  useEffect(() => {
    if (topbarCompanyId) {
      dispatch(setReloadHRMSApi(true));
    }
  }, [dispatch, topbarCompanyId]);

  useEffect(() => {
    if (reloadHRMSApi && topbarCompanyId) {
      fetchStatus();
    }
  }, [fetchStatus, reloadHRMSApi, topbarCompanyId]);

  const status = [
    {
      name: "All",
      count: departmentMembers?.overall_count || 0,
      status_tag: "",
      color: getStatusColor("Active"),
    },
    {
      name: "Present",
      count: departmentMembers?.present_count || 0,
      status_tag: "P1",
      color: getStatusColor("Active"),
    },
    {
      name: "Absent",
      count: departmentMembers?.absent_count || 0,
      status_tag: "A",
      color: getStatusColor("Absent"),
    },
    {
      name: "Late",
      count: departmentMembers?.late_count || 0,
      status_tag: "L1",
      color: getStatusColor("Late"),
    },
    {
      name: "OverTime",
      count: departmentMembers?.overtime_count || 0,
      status_tag: "OT",
      color: getStatusColor("Late"),
    },
  ];
  const nestedStatusForAll = [
    {
      name: "Planned",
      count: departmentMembers?.planned_count || 0,
      status_tag: "P2",
      color: getStatusColor("Active"),
    },
    {
      name: "Leave",
      count: departmentMembers?.leave_count || 0,
      status_tag: "L",
      color: getStatusColor("Leave"),
    },
    {
      name: "Week off",
      count: departmentMembers?.weekoff_count || 0,
      status_tag: "W",
      color: getStatusColor("Week off"),
    },
  ];

  const nestedStatusForPresent = [
    {
      name: "Active",
      count: departmentMembers?.active_count || 0,
      status_tag: "P",
      color: getStatusColor("Active"),
    },
    {
      name: "Break",
      count: departmentMembers?.break_count || 0,
      status_tag: "BR",
      color: getStatusColor("Break"),
    },
    {
      name: "Missing",
      count: departmentMembers?.missing_count || 0,
      status_tag: "M",
      color: getStatusColor("Missing"),
    },
    {
      name: "Out",
      count: departmentMembers?.out_count || 0,
      status_tag: "O",
      color: getStatusColor(""),
    },
  ];

  useEffect(() => {
    const filteredList = departmentMembers?.user_status_details;
    setFilterDepartMemberList(filteredList ? filteredList : []);
    setMasterDataForSearch(filteredList ? filteredList : []);
  }, [departmentMembers?.user_status_details, selectedValue]);

  useEffect(() => {
    const FilterDockets = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toLowerCase()) > -1
            : null
        )
      );
    };
    setFilterDepartMemberList(FilterDockets());
    setPage(0);
  }, [globalSearchValue, masterDataForSearch]);

  const summarizeExport = () => {
    if (filterDepartMemberList.length !== 0) {
      let dataPreparation = [];
      filterDepartMemberList?.forEach((element) => {
        let overAllData = {
          employee_id: element.employee_id,
          user_name: element.user_name,
          user_code: element.user_code,
          check_in_time_formatted: element.check_in_time_formatted,
          total_break_time: element.total_break_time,
          check_out_time_formatted: element.check_out_time_formatted,
          total_over_time: element.total_over_time,
          total_work_time: element.total_work_time,
          status: element.status,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      const department = ["Department Name"];
      const shift = ["Shift Name"];
      const givenDate = ["Date"];
      const downloadedat = ["Downloaded At"];
      department.push(departmentName);
      shift.push(shiftName);
      givenDate.push(formatDate(date));
      downloadedat.push(formattedDateTime);
      const items = dataPreparation;
      const TableHead = ["Employee Id"];
      TableHead.push("Username");
      TableHead.push("User Code");
      TableHead.push("Check In");
      TableHead.push("Breaks");
      TableHead.push("Check Out");
      TableHead.push("Over Time");
      TableHead.push("Working Hours");
      TableHead.push("Status");

      const replacer = (key, value) => (value === null ? "" : value);
      const header = Object.keys(items[0]);
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(",");
      csv.unshift(downloadedat.join(","));
      csv.unshift(givenDate.join(","));
      csv.unshift(shift.join(","));
      csv.unshift(department.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "SummarizedReported.csv";
      document.body.appendChild(element);
      element.click();
    } else {
      showToast("error", "No data available");
    }
  };

  const getMaxDate = () => {
    const today = new Date();
    today.setDate(today.getDate());
    return today.toISOString().split("T")[0];
  };

  const handleChange = (event) => {
    const value = event.target.value;
    const maxDate = getMaxDate();
    if (value !== "" && event.target.value <= maxDate) {
      if (/^\d{0,4}-?\d{0,2}-?\d{0,2}$/.test(value)) {
        setDate(value);
        dispatch(setAttendanceDate(value));
        localStorage.setItem("attendanceDate", value);
      }
    } else {
      setDate(maxDate);
    }
  };

  const handleBlur = () => {
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateFormatRegex.test(date)) {
      const inputDate = moment(date, "YYYY-MM-DD");
      if (inputDate.isValid()) {
        setDate(inputDate.format("YYYY-MM-DD"));
      } else {
        showToast("error", "Invalid date format");
      }
    } else {
      showToast("error", "Invalid date format");
    }
  };

  const handleFilterClick = () => {
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (shiftName && topbarCompanyName && dateFormatRegex.test(date)) {
      const inputDate = moment(date, "YYYY-MM-DD");
      const cutoffDate = moment("2020-01-01");

      if (inputDate.isValid()) {
        if (inputDate.isBefore(cutoffDate)) {
          showToast("error", "Date must be on or after January 1, 2020");
        } else {
          setDate(inputDate.format("YYYY-MM-DD"));
          dispatch(setReloadHRMSApi(true));
        }
      } else {
        showToast("error", "Invalid date format");
      }
    } else {
      showToast("error", "Invalid date format");
    }
  };

  // const handleCompanyName = (event, data) => {
  //   if (data) {
  //     setAdminCompanyName(data.label);
  //     setAdminCompanyId(data.id);
  //     dispatch(setAttendanceCompanyId(data?.id));
  //     dispatch(setAttendanceCompanyName(data?.label));
  //     localStorage.setItem("attendanceCompanyId", data?.id);
  //     localStorage.setItem("attendanceCompanyName", data?.label);
  //   }
  // };

  const shiftChange = (event, data) => {
    if (data && data?.label) {
      setshiftId(data.id);
      setShiftName(data.label);
      setPage(0);
      dispatch(setAttendanceShiftId(data?.id));
      dispatch(setAttendanceShiftName(data?.label));
      localStorage.setItem("attendanceShiftId", data?.id);
      localStorage.setItem("attendanceShiftName", data?.label);
      // dispatch(setReloadHRMSApi(true));
    }
  };

  const handleDepartmentChanges = (event, data) => {
    if (data && data.label) {
      dispatch(setDepartmentName(data.label));
      localStorage.setItem(
        "approveLeaveDepartmentId",
        data.id ? data.id : 99999
      );
      localStorage.setItem("approveLeaveDepartmentName", data.label);
      dispatch(setDepartmentId(data.id ? data.id : 99999));
      fetchShiftDetailsDetails(data.id ? data.id : 99999, data.label);
    }
    dispatch(setReloadHRMSApi(true));
    setPage(0);
  };

  return (
    <React.Fragment>
      <Mui.Grid
        container
        sx={{
          paddingTop: 2.5,
        }}
      >
        <Mui.Grid xs={12} sm={12} md={12} lg={0.4} xl={0.4}>
          <BackArrow
            actionFunction={() => history.push("/admin/teamzone/attendance")}
          />
        </Mui.Grid>
        <Mui.Grid
          xs={12}
          sm={12}
          md={12}
          lg={2}
          xl={2}
          sx={{ paddingTop: 0.5 }}
        >
          <CustomAutoComplete
            label="Select Department"
            dataList={departmentData}
            selectedValue={departmentName}
            updateDataFunction={handleDepartmentChanges}
            placeHolder="Select the department"
          />
        </Mui.Grid>
        <Mui.Grid
          xs={12}
          sm={12}
          md={12}
          lg={2.5}
          xl={2.5}
          sx={{ paddingTop: 0.5 }}
        ></Mui.Grid>
        <Mui.Grid xs={12} sm={12} md={12} lg={7.1} xl={7.1}>
          <Mui.Grid container>
            <Mui.Grid
              container
              xs={0}
              sm={0}
              md={0}
              lg={0.8}
              xl={0.8}
              sx={{ padding: 0.5 }}
            ></Mui.Grid>
            <Mui.Grid
              xs={12}
              sm={12}
              md={12}
              lg={3}
              xl={3}
              sx={{ padding: 0.5 }}
            ></Mui.Grid>
            <Mui.Grid
              xs={12}
              sm={12}
              md={12}
              lg={3}
              xl={3}
              sx={{ padding: 0.5 }}
            >
              <CustomAutoComplete
                dataList={shiftData?.map((obj) => ({
                  ...obj,
                  label: obj?.name,
                }))}
                selectedValue={shiftName}
                updateDataFunction={shiftChange}
                placeHolder="Select shift"
                label="Select Shift"
              />
            </Mui.Grid>
            <Mui.Grid
              xs={12}
              sm={12}
              md={12}
              lg={3}
              xl={3}
              sx={{ padding: 0.5 }}
            >
              <Mui.TextField
                type="date"
                size="small"
                label="Select Date"
                value={date}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                  max: getMaxDate(),
                }}
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid
              xs={2.5}
              sm={1.2}
              md={1}
              lg={1}
              xl={1}
              sx={{ padding: 0.5 }}
            >
              <CustomButton
                actionFuntion={handleFilterClick}
                actionName="Filter"
                typeName="button"
                onClick={handleFilterClick}
              />
            </Mui.Grid>
            <Mui.Grid
              xs={1.5}
              sm={1}
              md={1}
              lg={0.5}
              xl={0.5}
              sx={{ padding: 0.5 }}
            >
              <Mui.IconButton
                onClick={() => summarizeExport()}
                style={{
                  width: "40px",
                  height: "40px",
                  color: themes.downloadIconColor,
                  backgroundColor: themes.primary,
                }}
              >
                <DownloadForOffline fontSize="large" />
              </Mui.IconButton>
            </Mui.Grid>
            <Mui.Grid
              xs={1}
              sm={0.5}
              md={0.5}
              lg={0.5}
              xl={0.5}
              sx={{ padding: 0.5 }}
            >
              <Mui.IconButton
                aria-label="close"
                onClick={() =>
                  view === "List" ? setView("Card") : setView("List")
                }
              >
                {view === "List" ? (
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Card View"
                    placement="bottom"
                    key="card-view-tooltip"
                  >
                    <CreditCard
                      style={{
                        color: themes.headLine,
                      }}
                    />
                  </Mui.Tooltip>
                ) : (
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="List View"
                    placement="bottom"
                    key="list-view-tooltip"
                  >
                    <List
                      style={{
                        color: themes.headLine,
                      }}
                    />
                  </Mui.Tooltip>
                )}
              </Mui.IconButton>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.Grid>
      {!deviceOffine && (
        <Mui.Grid container sx={{ paddingBottom: 2, paddingTop: 3 }}>
          <Mui.Grid xs={12} sm={12} md={12} lg={3}></Mui.Grid>
          <Mui.Grid
            xs={12}
            sm={12}
            md={12}
            lg={6}
            sx={{ paddingRight: { md: 5, sm: 5 } }}
          >
            <Mui.Card
              style={{
                display: "flex",
                flexDirection: "row",
                borderRadius: 10,
                width: "100%",
                justifyContent: "space-evenly",
                marginLeft: 20,
                marginRight: 20,
                borderColor: themes.primary,
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: themes.backgroundShadow,
              }}
            >
              {status?.map((value) => (
                <>
                  <Mui.Card
                    style={{
                      display: "flex",
                      alignSelf: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "50%",
                      height: 50,
                      fontSize: 20,
                      fontWeight: "bold",
                      borderRadius: 0,
                      color: themes.headLine,
                      backgroundColor:
                        selectedValue === value?.name
                          ? themes.primaryIndicator
                          : themes.backgroundShadow,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatusTag(value?.status_tag);
                      setExpand(true);
                      setSelectedValue(value?.name);
                      setEditCheckinDetailsId(0);
                      setEditCheckInCheckOutDetails(null);
                      setPage(0);
                      dispatch(setReloadHRMSApi(true));
                      setAllTagStatus("");
                      setPresentTag("");
                    }}
                  >
                    <Mui.Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: 16, sm: 18, md: 20 },
                      }}
                    >
                      {value?.name}{" "}
                      <Mui.Box
                        component="span"
                        sx={{
                          color: value.color,
                        }}
                      >
                        {value?.count}
                      </Mui.Box>
                    </Mui.Typography>
                  </Mui.Card>
                </>
              ))}
            </Mui.Card>
          </Mui.Grid>
          <Mui.Grid xs={12} sm={12} md={12} lg={3}></Mui.Grid>
        </Mui.Grid>
      )}
      {selectedValue === "All" && !deviceOffine ? (
        <Mui.Grid container>
          <Mui.Grid container>
            <Mui.Grid xs={12} sm={12} md={3.5} lg={3.5}></Mui.Grid>
            <Mui.Grid
              xs={12}
              sm={12}
              md={5}
              lg={5}
              sx={{ paddingRight: { md: 5, sm: 5 } }}
            >
              <Mui.Card
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderRadius: 10,
                  width: "100%",
                  justifyContent: "space-evenly",
                  marginLeft: 20,
                  marginRight: 20,
                  borderColor: themes.primary,
                  borderWidth: "1px",
                  borderStyle: "solid",
                  backgroundColor: themes.backgroundShadow,
                }}
              >
                {nestedStatusForAll?.map((value) => (
                  <Mui.Card
                    sx={{
                      display: "flex",
                      alignSelf: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "50%",
                      height: 50,
                      borderRadius: 0,
                      color: themes.headLine,
                      backgroundColor:
                        allTagStatus === value?.name
                          ? themes.backgroundShadow
                          : themes.whiteColor,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatusTag(value?.status_tag);
                      setExpand(true);
                      setAllTagStatus(value?.name);
                      setEditCheckinDetailsId(0);
                      setEditCheckInCheckOutDetails(null);
                      setPage(0);
                      dispatch(setReloadHRMSApi(true));
                    }}
                  >
                    <Mui.Typography
                      sx={{
                        fontSize: { xs: 16, sm: 18, md: 20 },
                        fontWeight: "bold",
                      }}
                    >
                      <Mui.Box
                        component="span"
                        sx={{
                          color:
                            allTagStatus === value?.name
                              ? themes.headLine
                              : themes.shadowText,
                        }}
                      >
                        {value?.name}
                      </Mui.Box>{" "}
                      <Mui.Box
                        component="span"
                        sx={{
                          color: value.color,
                        }}
                      >
                        {value?.count}
                      </Mui.Box>
                    </Mui.Typography>
                  </Mui.Card>
                ))}
              </Mui.Card>
            </Mui.Grid>
            <Mui.Grid xs={12} sm={12} md={3.5} lg={3.5}></Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      ) : selectedValue === "Present" && !deviceOffine ? (
        <Mui.Grid container>
          <Mui.Grid container>
            <Mui.Grid xs={12} sm={12} md={3.5} lg={3.5}></Mui.Grid>
            <Mui.Grid
              xs={12}
              sm={12}
              md={5}
              lg={5}
              sx={{ paddingRight: { md: 5, sm: 5 } }}
            >
              <Mui.Card
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderRadius: 10,
                  width: "100%",
                  justifyContent: "space-evenly",
                  marginLeft: 20,
                  marginRight: 20,
                  borderColor: themes.primary,
                  borderWidth: "1px",
                  borderStyle: "solid",
                  backgroundColor: themes.backgroundShadow,
                  cursor: "pointer",
                }}
              >
                {nestedStatusForPresent?.map((value) => (
                  <Mui.Card
                    style={{
                      display: "flex",
                      alignSelf: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "50%",
                      height: 50,
                      fontSize: 20,
                      fontWeight: "bold",
                      borderRadius: 0,
                      color: themes.headLine,
                      cursor: "pointer",
                      backgroundColor:
                        presentTag === value?.name
                          ? themes.primary
                          : themes.whiteColor,
                    }}
                    onClick={() => {
                      setStatusTag(value?.status_tag);
                      setExpand(true);
                      setPresentTag(value?.name);
                      setEditCheckinDetailsId(0);
                      setEditCheckInCheckOutDetails(null);
                      setPage(0);
                      dispatch(setReloadHRMSApi(true));
                    }}
                  >
                    <Mui.Typography
                      sx={{
                        fontSize: { xs: 16, sm: 18, md: 20 },
                        fontWeight: "bold",
                      }}
                    >
                      <Mui.Box
                        component="span"
                        sx={{
                          color:
                            presentTag === value?.name
                              ? themes.headLine
                              : themes.shadowText,
                        }}
                      >
                        {value?.name}
                      </Mui.Box>{" "}
                      <Mui.Box
                        component="span"
                        sx={{
                          color: value.color,
                        }}
                      >
                        {value?.count}
                      </Mui.Box>
                    </Mui.Typography>
                  </Mui.Card>
                ))}
              </Mui.Card>
            </Mui.Grid>
            <Mui.Grid xs={12} sm={12} md={3.5} lg={3.5}></Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      ) : null}
      {deviceOffine ? (
        <>
          <Mui.Grid sx={{ paddingTop: 1 }}>
            <Device />
          </Mui.Grid>
        </>
      ) : (
        ""
      )}
      <StyledGrid container sx={{ paddingTop: deviceOffine ? 0 : 4 }}>
        <ContentGrid
          item
          xs={12}
          sx={{
            paddingTop: {
              xs: deviceOffine ? 0 : 5,
              md: deviceOffine ? 0 : 7,
              sm: deviceOffine ? 0 : 8,
              lg: 0,
            },
          }}
        >
          {loading ? (
            <LoaderWithoutHeight info="Loading..." />
          ) : view === "List" && !deviceOffine ? (
            <ListView
              editCheckinDetailsId={editCheckinDetailsId}
              setEditCheckinDetailsId={setEditCheckinDetailsId}
              editCheckinCheckOutTime={editCheckinCheckOutTime}
              setEditCheckInCheckOutDetails={setEditCheckInCheckOutDetails}
              departmentMembers={departmentMembers}
              filterDepartMemberList={filterDepartMemberList}
              expand={expand}
              setExpand={setExpand}
              setReloadHRMSApi={setReloadHRMSApi}
              page={page}
              setPage={setPage}
              setHandleLoading={setHandleLoading}
              setUserId={setUserId}
              setGetUser={setGetUser}
              shiftDetails={shiftDetails}
              setShiftDetails={setShiftDetails}
              firstTime={firstTime}
              setFirstTime={setFirstTime}
              fetchStatus={fetchStatus}
              openSidePeek={openSidePeek}
              setOpenSidePeek={setOpenSidePeek}
              departmentId={departmentId}
              masterDataForSearch={masterDataForSearch}
            />
          ) : (
            !deviceOffine && (
              <CardView
                departmentMembers={departmentMembers}
                setDepartmentMembers={setDepartmentMembers}
                filterDepartMemberList={filterDepartMemberList}
                expand={expand}
                setExpand={setExpand}
                page={page}
                setPage={setPage}
                masterDataForSearch={masterDataForSearch}
                loading={loading}
                setShiftDetails={setShiftDetails}
                setUserId={setUserId}
                setGetUser={setGetUser}
                setOpenSidePeek={setOpenSidePeek}
                openSidePeek={openSidePeek}
                shiftDetails={shiftDetails}
                fetchStatus={fetchStatus}
                departmentId={departmentId}
              />
            )
          )}
        </ContentGrid>
      </StyledGrid>
    </React.Fragment>
  );
};

const StyledGrid = styled(Mui.Grid)`
  height: 20vh;
  // overflow: hidden; /* Hide the scrollbar of the main container */
`;

const ContentGrid = styled(Mui.Grid)`
  width: 80%;
`;
